import React, { useEffect, useState, useContext, createRef } from "react";

import FirebaseContext from "../firebase/firebaseContext";
import EventContext from "../event/eventContext";
import LessonListItem from "./LessonListItem";

const LessonList = ({ hw }) => {
  const firebaseContext = useContext(FirebaseContext);
  const eventContext = useContext(EventContext);
  const { homework, filterList } = eventContext;
  const [grade, setGrade] = useState();
  const [teacher, setTeacher] = useState();
  const [show, setShow] = useState(false);
  const onSubmit = e => {
    e.preventDefault();
    filterList(grade);
    setShow(true);
  };

  let homeworkToDisplay;
  if (homework === null) {
    homeworkToDisplay = (
      <div className='select-container'>
        <h1 className='heading-error'>Ni še izbranega predmeta</h1>
      </div>
    );
  } else if (homework.length === 0) {
    homeworkToDisplay = (
      <div className='select-container'>
        <h1 className='heading-error'>
          Učna ura še ni dodana. Vrni se kasneje.
        </h1>
      </div>
    );
  } else {
    homeworkToDisplay = homework.map(hw => {
      return <LessonListItem hw={hw} />;
    });
  }
  return (
    <section className='event-list'>
      <div>
        <div className='naloge-banner'>
          <h1>Učne ure</h1>
          <h2>biologija in naravoslovje</h2>
        </div>
        <div className='naloge-title'>
          <h1>Izberi razred in klikni "Potrdi"</h1>
        </div>
        <div className='naloge-container'>
          <div className='select-container'>
            <form onSubmit={e => onSubmit(e)}>
              <select
                value={grade}
                onChange={e => {
                  setGrade(e.target.value);
                }}
              >
                <option value='0. razred'>Izberi razred</option>
                <option value='6.a'>6.a razred</option>
                <option value='6.b'>6.b razred</option>
                <option value='7.a'>7.a razred</option>
                <option value='7.b'>7.b razred</option>
                <option value='8.a'>8.a razred</option>
                <option value='8.b'>8.b razred</option>
                <option value='9.a'>9.a razred</option>
                <option value='9.b'>9.b razred</option>
                <option value='ono'>ONO</option>
                <option value='rod'>ROD</option>
              </select>
              {!grade ? (
                <button type='submit' disabled>
                  Potrdi
                </button>
              ) : (
                <button type='submit'>Potrdi</button>
              )}
            </form>
          </div>
        </div>
        <div className='izbrane-container'> {homeworkToDisplay}</div>
      </div>
    </section>
  );
};

export default LessonList;
